/* src/app/components/common/icon-button/icon-button.component.scss */
.custom-button {
  background-color: transparent;
  color: #000000;
  border: none;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.custom-button:hover {
  background-color: #dedede;
}
.custom-button:disabled {
  background-color: #d6d6d6;
  cursor: not-allowed;
}
.custom-button .mat-ripple-element {
  background-color: rgba(0, 0, 0, 0.1);
}
/*# sourceMappingURL=icon-button.component.css.map */
